import Vue from 'vue';

const STORAGE_KEY = 'seowritee_ui_v1';

export type UiSkin = 'default' | 'bordered';
export type ThemePreference = 'light' | 'dark' | 'system';

interface UiState {
    primaryColor: string;
    skin: UiSkin;
    themePreference: ThemePreference;
}

const DEFAULTS: UiState = {
    primaryColor: '#0770b8',
    skin: 'default',
    themePreference: 'light',
};

function loadState(): UiState {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
    } catch { /* ignore */ }
    return { ...DEFAULTS };
}

export const UiSettings = Vue.observable<UiState>(loadState());

function persist(): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            primaryColor: UiSettings.primaryColor,
            skin: UiSettings.skin,
            themePreference: UiSettings.themePreference,
        }));
    } catch { /* ignore */ }
}

export function setUiPrimaryColor(color: string): void {
    UiSettings.primaryColor = color;
    persist();
}

export function setUiSkin(skin: UiSkin): void {
    UiSettings.skin = skin;
    persist();
}

export function setUiThemePreference(pref: ThemePreference): void {
    UiSettings.themePreference = pref;
    persist();
}

export function resetUiSettings(): void {
    UiSettings.primaryColor = DEFAULTS.primaryColor;
    UiSettings.skin = DEFAULTS.skin;
    UiSettings.themePreference = DEFAULTS.themePreference;
    persist();
}
